import React from 'react';
import { FaTimes } from 'react-icons/fa';

const ThemedNotification = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'info', // 'info', 'success', 'warning', 'error'
  showAuthButtons = false,
  onSignUp,
  onLogin
}) => {
  if (!isOpen) return null;

  const getTitleColor = () => {
    switch (type) {
      case 'success':
        return 'text-green-800';
      case 'warning':
        return 'text-amber-800';
      case 'error':
        return 'text-red-800';
      default:
        return 'text-amber-800';
    }
  };

  const getMessageColor = () => {
    switch (type) {
      case 'success':
        return 'text-green-700';
      case 'warning':
        return 'text-amber-700';
      case 'error':
        return 'text-red-700';
      default:
        return 'text-amber-700';
    }
  };

  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    border: '1px solid #fbbf24',
    maxWidth: '24rem',
    width: 'calc(100vw - 2rem)',
    padding: '1.25rem',
    textAlign: 'center'
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 9998
  };

  return (
    <>
      <div style={overlayStyle} onClick={onClose}></div>
      <div style={modalStyle}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0.75rem',
            right: '0.75rem',
            color: '#f59e0b',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}
          onMouseEnter={(e) => e.target.style.color = '#d97706'}
          onMouseLeave={(e) => e.target.style.color = '#f59e0b'}
        >
          <FaTimes />
        </button>

        {/* Title */}
        <h3 style={{
          fontSize: '1.125rem',
          fontWeight: '600',
          marginBottom: '0.75rem',
          color: getTitleColor().includes('amber') ? '#92400e' : getTitleColor().includes('red') ? '#991b1b' : getTitleColor().includes('green') ? '#166534' : '#92400e'
        }}>
          {title}
        </h3>

        {/* Message */}
        <p style={{
          marginBottom: '1.25rem',
          fontSize: '0.875rem',
          lineHeight: '1.5',
          color: getMessageColor().includes('amber') ? '#a16207' : getMessageColor().includes('red') ? '#dc2626' : getMessageColor().includes('green') ? '#16a34a' : '#a16207'
        }}>
          {message}
        </p>

        {/* Auth buttons (if needed) */}
        {showAuthButtons && (
          <div style={{ marginBottom: '1rem' }}>
            <button
              onClick={() => {
                onClose();
                if (onSignUp) onSignUp();
              }}
              style={{
                width: '100%',
                background: 'linear-gradient(to right, #f59e0b, #fbbf24)',
                color: 'white',
                padding: '0.625rem 1rem',
                borderRadius: '0.5rem',
                border: 'none',
                marginBottom: '0.75rem',
                cursor: 'pointer',
                fontWeight: '500',
                fontSize: '0.875rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}
              onMouseEnter={(e) => e.target.style.background = 'linear-gradient(to right, #d97706, #f59e0b)'}
              onMouseLeave={(e) => e.target.style.background = 'linear-gradient(to right, #f59e0b, #fbbf24)'}
            >
              Start Your Artist Journey
            </button>
            <button
              onClick={() => {
                onClose();
                if (onLogin) onLogin();
              }}
              style={{
                width: '100%',
                background: 'white',
                color: '#a16207',
                padding: '0.625rem 1rem',
                borderRadius: '0.5rem',
                border: '1px solid #fbbf24',
                cursor: 'pointer',
                fontWeight: '500',
                fontSize: '0.875rem'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#fef3c7'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              Welcome Back
            </button>
          </div>
        )}

        {/* Close button (if no auth buttons) */}
        {!showAuthButtons && (
          <button
            onClick={onClose}
            style={{
              width: '100%',
              background: 'linear-gradient(to right, #f59e0b, #fbbf24)',
              color: 'white',
              padding: '0.625rem 1rem',
              borderRadius: '0.5rem',
              border: 'none',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '0.875rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
            onMouseEnter={(e) => e.target.style.background = 'linear-gradient(to right, #d97706, #f59e0b)'}
            onMouseLeave={(e) => e.target.style.background = 'linear-gradient(to right, #f59e0b, #fbbf24)'}
          >
            Got it!
          </button>
        )}

        {/* Footer text */}
        {showAuthButtons && (
          <p style={{
            fontSize: '0.75rem',
            color: '#d97706',
            marginTop: '1rem'
          }}>
            Join thousands of young artists creating amazing art together!
          </p>
        )}
      </div>
    </>
  );
};

export default ThemedNotification; 